import React from 'react';
import IndexPage from "./IndexPage";

const keyName = 'ResoursesPage';
export default class ResoursesPage extends IndexPage {
}
